/* ============================================================
   CLARTÉ PARIS — scroll reveal
   Gentle fade + blur reveal as sections enter the viewport.
   - Only opacity / transform / filter are animated → no layout shift.
   - Respects prefers-reduced-motion.
   - Progressive enhancement: if this never runs, content stays visible.
   - The first in-view section (hero) is left untouched to avoid any
     first-paint flash.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(
      main.querySelectorAll(':scope > .shopify-section')
    );
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    sections.forEach(function (section, index) {
      // Skip the first section (hero) so the page never flashes on load.
      if (index === 0) return;

      var top = section.getBoundingClientRect().top;
      // Anything already comfortably in view on load is shown immediately
      // (no hide → no flash); only below-the-fold sections animate in.
      if (top < viewportH * 0.85) return;

      section.classList.add('clarte-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
